import TabContent from './TabContent'
import VendorListConfig from './VendorListConfig'

const ConcurConfig = () => {
  const readerHelpIconProps = {
    builderPath: '',
    concurPath: '/concur/ja-JP/ocr-reader-doc/partner-settings.html#Partner',
    invoicePath: '',
    orderFormPath: '',
  }

  return (
    <TabContent
      title="取引先情報更新"
      readerHelpIconProps={readerHelpIconProps}
      description="Concurシステムより取引先情報の取得を行います。更新は、すべてのユーザーで最新の取引先情報に反映されます。"
      padding
    >
      <VendorListConfig />
    </TabContent>
  )
}

export default ConcurConfig
